import {Component, OnInit} from '@angular/core';
import {LoginService} from '../../shared/login.service';
import {I18NService} from '../../i18n/i18n.service';
import {MsgBoxService} from '../../shared/msg-box.service';
import {AuthErrorCode} from '../../api/errors';
import {errorCode} from '../../commons/commons';

@Component({
    selector: 'app-recover-pwd',
    templateUrl: './recover-pwd.component.html',
    styleUrls: ['./recover-pwd.component.scss']
})
export class RecoverPwdComponent implements OnInit {

    constructor(private readonly loginService: LoginService,
                private readonly i18n: I18NService,
                private readonly msgBoxService: MsgBoxService) {
    }

    ngOnInit() {
    }

    onPasswordRecovered() {
        this.loginService.notifyLogout();
    }

    onInfoOccurred(event: string) {
        this.msgBoxService.info(event);
    }

    onErrorOccurred(event: [string, Error]) {
        const msg = mkErrorMessage(event[1]) || event[0];
        this.msgBoxService.error(this.i18n.translate(msg), event[1]);
    }
}

function mkErrorMessage(err: Error): string {
    // NOTE: recover-password call is redirected to the Authentication Server, which provides its own set of error codes
    const code = errorCode(err);
    switch (code) {
        case AuthErrorCode.USED_PASSWORD:
            return 'Password already used';
        case AuthErrorCode.FORBIDDEN_WORDS:
            return 'Password contains words like name, surname, username or email';
        case AuthErrorCode.PASSWORD_NOT_STRONG:
            return 'Password is not strong enough';
        default:
            return null; // fall-back on message in auth-commons
    }
}
